import googleMapStyle from './googleMapStyle.json'

export const mapsOptions = {
  mapTypeControl: false,
  streetViewControl: false,
  fullscreenControl: false,
  styles: googleMapStyle,
}
